 if (isLoggedIn()) {
        window.location.href = 'dashboard.html';
    }

    // Populate dropdowns (Country removed, Grade and ACT dates remain)
    function populateDropdowns() {
        // Populate grades
        const gradeSelect = document.getElementById('grade');
        CONFIG.GRADES.forEach(grade => {
            const option = document.createElement('option');
            option.value = grade;
            option.textContent = grade;
            gradeSelect.appendChild(option);
        });

        // Populate ACT attempt dates
        const dateSelect = document.getElementById('act_attempt_date');
        CONFIG.ACT_ATTEMPT_DATES.forEach(date => {
            const option = document.createElement('option');
            option.value = date;
            option.textContent = date;
            dateSelect.appendChild(option);
        });
    }

    // Validate Contact Number input
    const contactInput = document.getElementById('contact_number');
    contactInput.addEventListener('input', function(e) {
        const value = this.value;
        
        // Visual feedback for contact number format
        const phoneRegex = /^\+\d{10,15}$/;
        if (phoneRegex.test(value)) {
            this.style.borderColor = 'var(--success-color)';
        } else if (value.length > 0) {
            this.style.borderColor = 'var(--warning-color)';
        } else {
            this.style.borderColor = 'var(--border-color)';
        }
    });

    // Validate ISBN input (only numbers, 13 digits)
    const isbnInput = document.getElementById('isbn_number');
    const isbnError = document.getElementById('isbnError');
    const isbnStatus = document.getElementById('isbnStatus');

    isbnInput.addEventListener('input', function(e) {
        // Remove non-digits
        this.value = this.value.replace(/\D/g, '');
        
        // Clear error when typing
        if (isbnError) {
            isbnError.style.display = 'none';
        }
        
        // Clear status
        if (isbnStatus) {
            isbnStatus.textContent = '';
            isbnStatus.className = 'isbn-status';
        }
        
        // Show visual feedback
        if (this.value.length === 13) {
            this.style.borderColor = 'var(--success-color)';
        } else if (this.value.length > 0) {
            this.style.borderColor = 'var(--warning-color)';
        } else {
            this.style.borderColor = 'var(--border-color)';
        }
    });

    // Real-time ISBN validation on blur
    isbnInput.addEventListener('blur', async function () {
        const isbn = this.value;
        if (isbn.length !== 13) return;

        // UI: show verifying + start spinner
        if (isbnStatus) {
            isbnStatus.textContent = 'Verifying ISBN...';
            isbnStatus.className = 'isbn-status verifying';
        }
        if (typeof showLoading === 'function') showLoading('Verifying ISBN...');

        try {
            const result = await sheetsAPI.validateISBN(isbn);

            if (!result.success) {
                isbnError.textContent = result.message || 'Unable to verify ISBN. Please try again.';
                isbnError.style.display = 'block';
                this.style.borderColor = 'var(--error-color)';
                if (isbnStatus) {
                    isbnStatus.textContent = '✗ ' + (result.message || 'Unable to verify ISBN');
                    isbnStatus.className = 'isbn-status error';
                }
            } else {
                isbnError.style.display = 'none';
                this.style.borderColor = 'var(--success-color)';
                if (isbnStatus) {
                    isbnStatus.textContent = '✓ Valid ISBN';
                    isbnStatus.className = 'isbn-status success';
                }
            }
        } catch (err) {
            console.error(err);
            isbnError.textContent = 'Network error while verifying ISBN.';
            isbnError.style.display = 'block';
            this.style.borderColor = 'var(--error-color)';
            if (isbnStatus) {
                isbnStatus.textContent = '✗ Network error';
                isbnStatus.className = 'isbn-status error';
            }
        } finally {
            // ALWAYS stop spinner, success or error
            if (typeof hideLoading === 'function') hideLoading();
        }
    });


    // Handle registration form submission
    document.getElementById('registerForm').addEventListener('submit', async (e) => {
        e.preventDefault();
        
        // Validate Contact Number
        const contactNumber = document.getElementById('contact_number').value;
        const phoneRegex = /^\+\d{10,15}$/;
        if (!phoneRegex.test(contactNumber)) {
            showMessage('Contact number must start with + followed by 10-15 digits (e.g., +1234567890)', 'error');
            return;
        }
        
        // Validate ISBN one more time before submission
        const isbnValue = document.getElementById('isbn_number').value;
        if (isbnValue.length !== 13) {
            showMessage('ISBN must be exactly 13 digits', 'error');
            return;
        }
        
        if (!/^\d{13}$/.test(isbnValue)) {
            showMessage('ISBN must contain only numbers', 'error');
            return;
        }
        
        const formData = new FormData(e.target);
        const result = await Auth.register(formData);
        
        if (result.success) {
            showMessage('Account created successfully! Your VP ID: ' + result.uid, 'success');
            setTimeout(() => {
                window.location.href = '/pages/act-dashboard';
            }, 2000);
        } else {
            showMessage(result.message, 'error');
        }
    });

    // Initialize dropdowns on page load
    populateDropdowns();